import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { ListarEscriturasController } from "../../../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import useToggle from "../../../../../hooks/useToggle";
import { IEscritura } from "../../../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import Table from "../../../../Table";
import OrSpinner from "../../../../Utils/OrSpinner";
import EditarStatusEscritura from "./EditarStatusEscritura";

interface IInfoEscrituraProps {
    lstEscriturasIds: Array<number>;
    loadingInfoVenda?: boolean;
    updateList(): void;
    ID_CHAVE_ERP: string;
}

export default function InfoEscritura(props: IInfoEscrituraProps) {
    const [editandoStatusEscritura, toggleStatusEscritura] = useToggle(false);
    const { value: lstEscritura, loading } = useAsyncEffect(async () => {
        if (props.lstEscriturasIds && props.lstEscriturasIds.length > 0)
            return ListarEscriturasController(props.lstEscriturasIds.join());
        else return [];
    }, [props.lstEscriturasIds]);
    const { Atendimento } = useAtendimentoPage();

    const podeEditar = Atendimento?.ID_CHAVE_ERP_VENDA === props.ID_CHAVE_ERP;

    return (
        <OrSpinner
            loading={Boolean(loading || props.loadingInfoVenda)}
            spinner="erp"
        >
            {editandoStatusEscritura ? (
                <EditarStatusEscritura
                    lstIdsEscritura={props.lstEscriturasIds}
                    then={() => {
                        props.updateList();
                        toggleStatusEscritura();
                    }}
                />
            ) : (
                <div>
                    <div className="w-100 justify-content-end d-flex my-2">
                        <div style={{ position: "relative" }}>
                            {!podeEditar && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="not-edit=status-escritura-tooltip">
                                            Para editar o status de escritura
                                            deste produto você deve abrir um
                                            atendimento para ele
                                        </Tooltip>
                                    }
                                    show={podeEditar ? false : undefined}
                                >
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "0",
                                            left: "0",
                                            width: "100%",
                                            height: "100%",
                                            zIndex: 2,
                                        }}
                                    />
                                </OverlayTrigger>
                            )}
                            <button
                                className="btn btn-primary d-flex align-items-center g-2"
                                onClick={toggleStatusEscritura}
                                disabled={!podeEditar}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                                Editar
                            </button>
                        </div>
                    </div>
                    <Table
                        columns={columns}
                        data={lstEscritura ?? []}
                        keyField="Codigo_ste"
                        loading={loading}
                        noDataIndication={() => (
                            <div className="text-muted text-center">
                                Venda não possui Escritura
                            </div>
                        )}
                    />
                </div>
            )}
        </OrSpinner>
    );
}

const columns: Array<ColumnDescription<IEscritura>> = [
    {
        dataField: "Desc_ste",
        text: "Escrituras",
        classes: "p-2",
    },
];
